import { createContext, useContext } from 'react';
import type { Catalog } from '@tg/app-core';
import type { Maxes } from '@tg/domain';
import type { Doc } from './model';

/* Общее состояние конструктора для строк и блоков */
export interface Ctx {
  doc: Doc;
  /** Правка документа; label — для отмены */
  update: (f: (d: Doc) => Doc) => void;
  catalog: Catalog;
  /** Максимумы клиента (у группы — пусто: вес у каждого свой) */
  pm: Maxes;
  isGroup: boolean;
  focus: { id: string; field: string } | null;
  setFocus: (id: string, field?: string) => void;
  /** Ввод 1ПМ прямо в строке (CON-16) */
  setMax: (key: string, kg: number) => void;
  toast: (text: string, undo?: () => void) => void;
  /** Выбор единицы до ввода числа — на сессию */
  unitSel: Record<string, string>;
  /** Открыть окно типа блока / сохранения в базу и т. п. */
  openTypePicker: (blockId: string) => void;
  saveBlockToBase: (blockId: string) => void;
  /** text — текущий текст из поля (в модель он мог ещё не попасть) */
  aiBlock: (blockId: string, text?: string) => void;
  /** Блок, который сейчас разбирает ИИ */
  aiBusy: string | null;
  aiLine: (lineId: string) => void;
  /** Добавить своё упражнение в базу (EX-2) и вернуть id */
  addOwnExercise: (name: string) => Promise<string | null>;
  /** Ширина колонки названий по блоку */
  nmw: Record<string, number>;
  /** Результаты клиента за этот день (у группы — пусто): показываются под блоком */
  results: ClientResult[];
}
export interface ClientResult {
  blockId: string;
  lineId: string;
  exId: string | null;
  plan: unknown;
  fact: unknown;
}

export const ConstructorCtx = createContext<Ctx>(null as unknown as Ctx);
export const useCtx = () => useContext(ConstructorCtx);

export const KB = (k: string) => `<kbd>${k}</kbd>`;
export const plural = (n: number, a: string, b: string, c: string) => {
  const m = n % 10,
    h = n % 100;
  return h >= 11 && h <= 14 ? c : m === 1 ? a : m >= 2 && m <= 4 ? b : c;
};
export const fmtN = (v: number | string | undefined | null) => (v == null || v === '' ? '' : String(v).replace('.', ','));
export const fw = (v: string, min: number, pad: number) => `calc(${Math.max(String(v).length, min)}ch + ${pad}px)`;
export const isMac = typeof navigator !== 'undefined' && /Mac|iPhone|iPad/.test(navigator.platform || navigator.userAgent);
